import { z } from 'zod';

/**
 * Every human-visible string in a definition is localizable. English is the
 * authoring baseline and always present; other locales (hi, …) are optional
 * and publish lint warns when the service's declared locales are missing.
 */
export const i18nTextSchema = z
  .record(z.string().min(2).max(8), z.string())
  .refine((v) => typeof v.en === 'string' && v.en.length > 0, {
    message: 'i18n text requires an "en" entry',
  });

export type I18nText = z.infer<typeof i18nTextSchema>;

export function resolveI18n(text: I18nText | undefined, locale: string): string {
  if (!text) return '';
  return text[locale] ?? text.en ?? '';
}
